// Página pública de aceite do convite da transportadora (PO1-2299). Usa o
// cliente anônimo: o token do link é o único controle de acesso, e um operador
// logado que abrir o link não pode mandar a própria sessão junto.
import apiPublic from "./apiPublic";

export async function previewConvite(token) {
  const { data } = await apiPublic.get(`/public/convite-transportadora/${encodeURIComponent(token)}`);
  return data;
}

// PO1-3646: convite da Rede Everlog leva `termoAceite: true` e a `termoVersao`
// do preview; convite de embarcador real segue sem os dois.
export async function aceitarConvite(token, { name, surname, userName, password, termoAceite, termoVersao } = {}) {
  const corpo = { name, surname, userName, password };
  if (termoAceite) {
    corpo.termoAceite = true;
    corpo.termoVersao = termoVersao;
  }
  const { data } = await apiPublic.post(`/public/convite-transportadora/${encodeURIComponent(token)}/aceitar`, corpo);
  return data;
}

export async function recusarConvite(token, { motivo } = {}) {
  const { data } = await apiPublic.post(`/public/convite-transportadora/${encodeURIComponent(token)}/recusar`, { motivo });
  return data;
}
